/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagKeyRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TagKeyRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return TagKeyRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TagKeyRegexQueryOperator>): TagKeyRegexQueryOperator {
        let obj = Object.assign(new TagKeyRegexQueryOperator(), model);
        TagKeyRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagKeyRegexQueryOperator>): TagKeyRegexQueryOperator {
        if (!model) return null;
        return TagKeyRegexQueryOperator.newInstance(<TagKeyRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagKeyRegexQueryOperator) {
        if (!obj) return;

        models.TagKeyRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagKeyRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagKeyRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tag_key) {
            models.Regex.fixupPrototype(this.tag_key);
        }
    }

    /**
     * Include response that has the given tag key
     */
    tag_key: models.Regex;

    /**
     * Tag kind if applicable
     */
    tag_kind: string;

}
